import React, {Component} from 'react';
import {browserHistory, Link, hashHistory} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {loginUser, fetchUser, loginWithProvider} from '../../actions/firebase_actions';
import utils from '../../utils/config.js';
import Privacy from '../documents/privacy/';
import Terms from '../documents/terms/';
import License from '../documents/license/';
import Copyright from '../documents/copyright/';
import Version_History from '../version_history/';
import {updateModal} from '../../actions/modal.js';
class UserLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      width: window.innerWidth
    };
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({width: window.innerWidth});
  };
  showModal(content) {
    var modalContent;
    if (content == 'privacy')
      modalContent = <Privacy/>;
    if (content == 'version')
      modalContent = <Version_History/>;
    if (content == 'terms')
      modalContent = <Terms/>;
    if (content == 'license')
      modalContent = <License/>;
    if (content == 'copyright')
      modalContent = <Copyright/>;
    this.props.updateModal(true, modalContent);
  }

  render() {
      var {currentUser} = this.props;
    var version = utils.getVersion();
    var copyright = utils.getCopyright();
    var twitter = utils.getTwitter();
    var appName = utils.getAppName();
    var companyLink = "Ambrose Gaming";
    var twitterLink = "@TrickStrat";
    var supportEmail = "support@trickstrat.com";
    var businessEmail = "rob@trickstrat.com";
    const {width} = this.state;
    const isMobile = width <= 760;
    var footerText;
    if (!isMobile) {
      footerText = <p className="dimDisplayName">
        <span className="linkText" onClick={(event) => {
          this.showModal('version');
        }}>{appName} {version}</span> {copyright}
        <span> - </span>
        Patent Pending
          <span> | </span>
        <span className="linkText" onClick={(event) => {
          this.showModal('terms');
        }}>Terms of Use</span>
      <span> | </span>
        <span className="linkText" onClick={(event) => {
          this.showModal('license');
        }}>End-User Agreement</span>
      <span> | </span>
        <span className="linkText" onClick={(event) => {
          this.showModal('privacy');
        }}>Privacy Policy</span>
      <span> | </span>
        <span className="linkText" onClick={(event) => {
          this.showModal('copyright');
        }}>Copyright Policy</span>
      </p>
    } else {
      footerText = <div className="copyrightFloat">
      <center><span className="dimLegalText floatLeft">{copyright}</span></center>
</div>
      ;
    }
    return (
      <div className="footer">
        {footerText}
      </div>

    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateModal
  }, dispatch);
}

function mapStateToProps(state) {
  return {currentUser: state.currentUser};
}

export default connect(mapStateToProps, mapDispatchToProps)(UserLogin);



// WEBPACK FOOTER //
// ./src/app/components/footer/index.jsx